module.exports = __webpack_public_path__ + "static/02-prototyping@2x-03d27b041008f953c77e984ee55816e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/homepage/02-prototyping@2x.jpg
// module id = 2640
// module chunks = 35783957827783